var fr = {
  "Add Quantity Breaks to your product page": "Ajoutez des remises sur quantité à votre page produit",
  "Add Upsell.com to your ": "Ajoutez Upsell.com à votre ",
  "All time": "Tout le temps",
  "and select": "et sélectionnez",
  "button": "bouton",
  "Cart drawer page": "Page de tiroir panier",
  "Cart page": "Page panier",
  "Check status": "Vérifier le statut",
  "Checkout page": "Page de paiement",
  "Click": "Cliquez sur",
  "Click on": "Cliquez sur",
  "Click the": "Cliquez sur le",
  "Custom slot": "Emplacement personnalisé",
  "Custom slots": "Emplacements personnalisés",
  "Custom Slots": "Emplacements personnalisés",
  "contact support.": "contactez le support.",
  "from the right sidebar": "de la barre latérale droite",
  "Go to App Embeds": "Aller aux intégrations d'applications",
  "Go to your Cart drawer page": "Allez à votre page de tiroir panier",
  "Go to your Cart page": "Allez à votre page panier",
  "Go to your Checkout page": "Allez à votre page de paiement",
  "Go to your Order status page": "Allez à votre page de statut de commande",
  "Go to your Post purchase page": "Allez à votre page post-achat",
  "Go to your Product page": "Allez à votre page produit",
  "Go to your Thank you page": "Allez à votre page de remerciement",
  "items": "articles",
  "in the left sidebar": "dans la barre latérale gauche",
  "Last 12 months": "12 derniers mois",
  "Last 30 days": "30 derniers jours",
  "Last 365 days": "365 derniers jours",
  "Last 7 days": "7 derniers jours",
  "Last 90 days": "90 derniers jours",
  "Last month": "Mois dernier",
  "Last year": "Année dernière",
  "Make sure": "Assurez-vous que",
  "Need assistance? Contact our support team for help.": "Besoin d'aide ? Contactez notre équipe de support.",
  "Order status page": "Page de statut de commande",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Notre application subit actuellement un peu de magie pour améliorer votre expérience.",
  "Post purchase page": "Page post-achat",
  "Product page": "Page produit",
  "Save": "Enregistrer",
  "Scroll to the bottom and select": "Faites défiler vers le bas et sélectionnez",
  "Select": "Sélectionner",
  "Success. Please continue.": "Succès. Veuillez continuer.",
  "Thank you page": "Page de remerciement",
  "The Upsell.com team.": "L'équipe Upsell.com.",
  "The Upsell.com widget is not placed on ": "Le widget Upsell.com n'est pas placé sur ",
  ". Please follow the steps above or ": ". Veuillez suivre les étapes ci-dessus ou ",
  "Today": "Aujourd'hui",
  "toggle is on": "le bouton est activé",
  "Total": "Total",
  "under": "sous",
  "We apologize for any inconvenience caused,": "Nous nous excusons pour tout désagrément causé,",
  "We apologize for any inconvenience caused.": "Nous nous excusons pour tout désagrément causé.",
  "We'll be done in a few minutes!": "Nous aurons terminé dans quelques minutes !",
  "We're improving our services!": "Nous améliorons nos services !",
  "Widget already added": "Widget déjà ajouté",
  "Yesterday": "Hier",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Vous avez activé le widget dans votre boutique en ligne, mais vous ne l'avez pas enregistré dans l'éditeur Upsell",
  "You placed the widget on the ": "Vous avez placé le widget sur ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", mais vous ne l'avez pas enregistré dans l'éditeur Shopify. Veuillez retourner à ",
  " and save the changes.": " et enregistrer les modifications."
};

export { fr as default };
//# sourceMappingURL=fr.json.js.map
